import React from 'react';
import FieldTypesEnum from '../../Enums/FieldTypesEnum';
import JsxHelper from '../../Helpers/JsxHelper';
import UserNameComponent from '../../Elements/UserNameComponent';
import DataTableActionMenu from '../../Elements/DataTable/DataTableActionMenu';
import urlHelper from '../../Helpers/urlHelper';
import { isEntryLocked, mapBaseFields, initBaseFields } from './outsourcedUserFteHelpers';

export default class FteTrackingItem {
  constructor(item) {
    if (item === undefined) {
      initBaseFields(this);
      this.UserOfficeId = '';
      this.UserOfficeName = '';
      this.IoblineItemId = null;
      this.IobinvoiceId = null;
      this.ReverseIobInvoiceId = null;
      this.Selected = false;
      return;
    }

    mapBaseFields(this, item);
    this.UserOfficeId = item.userOfficeId;
    this.UserOfficeName = item.userOfficeName;
    this.IoblineItemId = item.ioblineItemId;
    this.IobinvoiceId = item.iobinvoiceId;
    this.ReverseIobInvoiceId = item.reverseIobInvoiceId;
    this.Selected = false;
  }

  static displayedInList = 'FieldworkOfficeName';

  static NameOfTheIdField() {
    return 'OutsourcedUserFteid';
  }

  static MoneyFields = [];
  static Currency() {
    return '';
  }
  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return '';
  }
  static DateOnlyFields = [];
  static DateFields = [];
  static BoolFields = [];

  static nameOfTheItemDetailList(item) {
    if (item) return <span>FTE Entry - {item.FieldworkOfficeName}</span>;
    return 'FTE Entry Details';
  }

  static editFunction = (id, item) => {
    alert('Empty function');
  };

  static deleteFunction = (item) => {
    alert('Empty function');
  };

  static lockFunction = (item) => {
    alert('Empty function');
  };

  static reverseIobFunction = (item) => {
    alert('Empty function');
  };

  static clickOnSelect(item, selected) {
    //This is a placeholder, don't remove it!
  }

  static clickOnGlobalSelect(item, selected) {
    //This is a placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellHeader() {
    return (
      <div className='text-left'>
        <input
          type='checkbox'
          checked={FteTrackingItem.selectedStatus()}
          onChange={(e) => {
            FteTrackingItem.clickOnGlobalSelect(null, e.target.checked);
          }}
        />
      </div>
    );
  }

  static getSelectedCellContent(item) {
    return (
      <div className='text-left'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            FteTrackingItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static getActionsContent(item) {
    const locked = isEntryLocked(item);
    const isInvoiced = item.Status === 'Invoiced' || !!item.IoblineItemId;
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => FteTrackingItem.editFunction(item.OutsourcedUserFteid, item),
            roleKey: 'outsourcedfte_edit',
            disabled: locked,
          },
          {
            iconName: 'fa-solid fa-lock',
            text: 'Lock',
            onClick: () => FteTrackingItem.lockFunction(item),
            roleKey: 'outsourcedfte_lock',
            disabled: locked,
          },
          {
            iconName: 'fa-solid fa-rotate-left',
            text: 'Create Reverse IOB',
            onClick: () => FteTrackingItem.reverseIobFunction(item),
            roleKey: 'outsourcedfte_iobreverse',
            disabled: !isInvoiced,
          },
          {
            iconName: 'fa-regular fa-trash-can',
            text: 'Delete',
            onClick: () => FteTrackingItem.deleteFunction(item),
            roleKey: 'outsourcedfte_edit',
            disabled: locked,
          },
        ]}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      { label: FteTrackingItem.getSelectedCellHeader, orderById: '', data: FteTrackingItem.getSelectedCellContent, minWidth: 10 },
      {
        label: 'Name',
        orderById: 'UserName',
        data: (item) => <UserNameComponent userId={item.UserId} />,
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'FTE',
        orderById: 'Ftepercentage',
        // Ftepercentage is a percentage (0–100); show it as a fraction (50 -> 0.5) in this grid.
        data: (item) => (item.Ftepercentage == null ? '' : `${item.Ftepercentage / 100}`),
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Hiring Office',
        orderById: '',
        data: 'HiringOfficeName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Bill to Office',
        orderById: 'FieldworkOfficeName',
        data: 'FieldworkOfficeName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Start Date',
        orderById: 'StartDateUtc',
        data: 'StartDateUtc',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'End Date',
        orderById: 'EndDateUtc',
        data: 'EndDateUtc',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Status',
        orderById: 'Status',
        data: (item) => {
          if (item.Status === 'Invoiced' && item.IobinvoiceId) {
            return (
              <span>
                <i className='fa-solid fa-file-invoice-dollar text-success me-1'></i>
                {urlHelper.getIconLinkComponentFigma(
                  `IOB #${item.IobinvoiceId}`,
                  'fa-solid fa-arrow-up-right-from-square',
                  'text-success',
                  'iobdetails',
                  `id=${item.IobinvoiceId}`,
                  'Open IOB Invoice'
                )}
              </span>
            );
          }
          if (item.Status === 'Locked') {
            return <span><i className='fa-solid fa-lock text-warning me-1'></i>Locked</span>;
          }
          if (item.Status === 'Open') {
            return <span><i className='fa-solid fa-lock-open text-warning me-1'></i>Open</span>;
          }
          if (item.Status === 'Confirmed') {
            return <span><i className='fa-solid fa-circle-check text-success me-1'></i>Confirmed</span>;
          }
          return item.Status;
        },
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Reverse IOB',
        orderById: '',
        data: (item) => {
          if (item.ReverseIobInvoiceId) {
            return (
              <span>
                <i className='fa-solid fa-file-invoice-dollar text-danger me-1'></i>
                {urlHelper.getIconLinkComponentFigma(
                  `IOB #${item.ReverseIobInvoiceId}`,
                  'fa-solid fa-arrow-up-right-from-square',
                  'text-danger',
                  'iobdetails',
                  `id=${item.ReverseIobInvoiceId}`,
                  'Open Reverse IOB'
                )}
              </span>
            );
          }
          return null;
        },
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: ' ',
        orderById: '',
        data: FteTrackingItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static FieldsToShowInListTable = [];
}
